export const deleteReviewsFormFieldName = 'deleteReviews';
